/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
const { transparent } = colors;
const { borderRadius } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: "var(--app-field-bg)",
      fontSize: size.sm,
      borderRadius: borderRadius.md,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--app-field-border-hover)",
      },

      "&.Mui-focused": {
        boxShadow: "0 0 0 4px var(--app-field-ring)",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "var(--app-field-border-focus)",
        },
      },
    },

    notchedOutline: {
      borderColor: "var(--app-field-border)",
    },

    input: {
      color: "var(--app-field-text)",
      WebkitTextFillColor: "var(--app-field-text)",
      caretColor: "var(--app-field-text)",
      padding: pxToRem(12),
      backgroundColor: transparent.main,

      "&::placeholder": {
        color: "var(--app-field-placeholder)",
        opacity: 1,
      },

      "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus": {
        WebkitTextFillColor: "var(--app-field-text)",
        caretColor: "var(--app-field-text)",
        WebkitBoxShadow: "0 0 0 1000px var(--app-field-bg) inset",
      },
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10),
    },

    multiline: {
      color: "var(--app-field-text)",
      WebkitTextFillColor: "var(--app-field-text)",
      padding: 0,
    },
  },
};

export default inputOutlined;
